import { useContext, useMemo, useState } from "react";
import { AuthorsUtils, IAxiosError } from "../../../../utils";
import { NoDataPage } from "../../../shared/error/NoDataPage";
import { AvisContext } from "../../../shared/context";
import {
  CreationPageAudioVisual,
  CreationPageChoreographic,
  CreationPageMusical,
  CreationPagePublicLending,
  CreationPageVisual,
} from "./pages";

export function CreationPageRouter() {
  const { ctxRightsHolder } = useContext(AvisContext);
  const [error, setError] = useState<IAxiosError>();

  const urlParams = useMemo(
    () => AuthorsUtils.getUrlParams(ctxRightsHolder),
    [ctxRightsHolder],
  );

  const renderContent = useMemo(() => {
    switch (urlParams.creationType) {
      case "m":
        return (
          <CreationPageMusical
            urlParams={urlParams}
            error={error}
            setError={setError}
          />
        );
      case "av":
        return (
          <CreationPageAudioVisual
            urlParams={urlParams}
            error={error}
            setError={setError}
          />
        );
      case "h":
        return (
          <CreationPageChoreographic
            urlParams={urlParams}
            error={error}
            setError={setError}
          />
        );
      case "ppi":
        return (
          <CreationPagePublicLending
            urlParams={urlParams}
            error={error}
            setError={setError}
          />
        );
      case "v":
        return (
          <CreationPageVisual
            urlParams={urlParams}
            error={error}
            setError={setError}
          />
        );
      default:
        return <NoDataPage />;
    }
  }, [error, urlParams]);

  return renderContent;
}
